import { NgModule } from '@angular/core';
import {CommonModule, DecimalPipe} from '@angular/common';
import {MatCardModule} from "@angular/material/card";
import {MatIconModule} from "@angular/material/icon";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatButtonModule} from "@angular/material/button";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatInputModule} from "@angular/material/input";
import {AngularFireModule} from "@angular/fire/compat";
import {environment} from "../../environments/environment";
import {RouterModule} from "@angular/router";
import { LoadingComponent } from './loading/loading.component';
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {FlexLayoutModule} from "@angular/flex-layout";
import {MatSidenavModule} from "@angular/material/sidenav";
import { LayoutComponent } from './layout/layout.component';
import {MatCheckboxModule} from "@angular/material/checkbox";
import {NgSelectModule} from "@ng-select/ng-select";
import {MatToolbarModule} from "@angular/material/toolbar";
import {MatTooltipModule} from "@angular/material/tooltip";
// import {MatBadgeModule} from "@angular/material/badge";
import {MatListModule} from "@angular/material/list";
import {MatSelectModule} from "@angular/material/select";
import {MatDialogModule} from "@angular/material/dialog";
import { DialogComponent } from './dialog/dialog.component';
import {MatExpansionModule} from "@angular/material/expansion";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from "@angular/material/core";
import {StringDateAdapter} from "./string-date-adapter/string-date-adapter";
import {MAT_2DIGIT_DATE_FORMATS} from "./string-date-adapter/date-format";
import {KingakuPipe} from "../core/pipe/kingaku.pipe";
import {StringShortenPipe} from "../core/pipe/string-shorten.pipe";
import {MatTableModule} from "@angular/material/table";
import {MatSortModule} from "@angular/material/sort";
import {MatSnackBarModule} from "@angular/material/snack-bar";
import {InfoMessageComponent} from "./dialog/info-message/info-message.component";
import {ErrorMessageComponent} from "./dialog/error-message/error-message.component";
import {MatMenuModule} from "@angular/material/menu";
import {HttpClientModule} from "@angular/common/http";
import {PdfViewerModule} from "ng2-pdf-viewer";

@NgModule({
  declarations: [
    LoadingComponent,
    LayoutComponent,
    DialogComponent,
    KingakuPipe,
    StringShortenPipe,
    InfoMessageComponent,
    ErrorMessageComponent,
  ],
  imports: [
    RouterModule,
    CommonModule,
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatCheckboxModule,
    MatToolbarModule,
    MatTooltipModule,
    // MatBadgeModule,
    MatListModule,
    MatSelectModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    FlexLayoutModule,
    MatSidenavModule,
    MatDialogModule,
    MatExpansionModule,
    MatDatepickerModule,
    MatTableModule,
    MatSortModule,
    MatSnackBarModule,
    MatMenuModule,
    HttpClientModule,
    PdfViewerModule,
  ],
  providers: [MatDatepickerModule,
    /* Datepicker の多言語化 */
    {provide: MAT_DATE_LOCALE, useFactory: () => {
        if (navigator.languages !== undefined && navigator.languages.length > 0) {
          return navigator.languages[0];
        }
        if (navigator.language) {
          return navigator.language;
        }
        return 'en';
      }},
    {provide: DateAdapter, useClass: StringDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MAT_2DIGIT_DATE_FORMATS},
    DecimalPipe
  ],
  exports: [
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatCheckboxModule,
    MatToolbarModule,
    MatTooltipModule,
    // MatBadgeModule,
    MatListModule,
    MatSelectModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    LoadingComponent,
    FlexLayoutModule,
    MatSidenavModule,
    MatDialogModule,
    MatExpansionModule,
    MatDatepickerModule,
    KingakuPipe,
    StringShortenPipe,
    MatTableModule,
    MatSortModule,
    MatSnackBarModule,
    MatMenuModule,
    HttpClientModule,
    PdfViewerModule,
  ]
})
export class SharedModule { }
